/**
 *@file config.js
 *@version 1.0.1
 *@author wuwg
 *@createTime 2019/10/17 - 20:37
 *@updateTime 2019/10/17 - 20:37
 *@see [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 * @description    server-config.js.js ,所有服务器的url配置
 */
const dirServicePath = window.serverConfig.dirServicePath;
const statisticsServicePath = window.serverConfig.statisticsServicePath;
// 服务数据
const serverUrl = {
    // 测试模块
    test:{
        // 测试模块首页数据
        index: `${dirServicePath}/rest/index`
    },
    home:{list: `${dirServicePath}/api/v1/fbnr/home`},
    common:{
        list: `${dirServicePath}/api/v1/fbnr/wwlist`,
        detail: `${dirServicePath}/api/v1/fbnr/detail/{id}`,
        filter: `${dirServicePath}/api/v1/fbnr/flfg/gbjg`
    },
    wj:{
        list: `${dirServicePath}/api/v1/wj/page`,
        // 文件下载
        download:`${dirServicePath}/api/v1/wj/action/download/{id}`
    },
    statistics:{
        // 审判案件统计
        sp: `${statisticsServicePath}/api/v2/hsajtj/spajtj/hsfy`,
        // 执行案件统计
        zx: `${statisticsServicePath}/api/v2/hsajtj/zxajtj/hsfy`,
        // 涉外案件统计
        sw: `${statisticsServicePath}/api/v2/hsajtj/swajtj`,
        // 涉港澳台案件统计
        gat: `${statisticsServicePath}/api/v2/hsajtj/sgqtajtj`
    }
};
export default serverUrl;
